import { Divider } from '@mui/material';
import Box from '@mui/material/Box';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useState } from 'react';
import useDose from '~/hooks/patient/dose/useDose';
import DoseActions from './DoseActions';
import DoseDetails from './DoseDetails';
import DoseTitle from './DoseTitle';

export default function Doses() {
    const [isExpanded, setIsExpanded] = useState(true);
    const { dose } = useDose();
    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        dose && (
            <>
                <Divider />
                <Box position="relative" px={2}>
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Box
                            display="flex"
                            alignItems="center"
                            gap={0.5}
                            onClick={toggleExpand}
                            sx={(theme) => ({
                                cursor: 'pointer',
                                color: theme.palette.primary.main,
                            })}
                        >
                            <Box display="flex" alignItems="center">
                                {isExpanded ? (
                                    <ChevronDown size={14} />
                                ) : (
                                    <ChevronUp size={14} />
                                )}
                            </Box>
                            <DoseTitle dose={dose} />
                        </Box>
                        <DoseActions dose={dose} />
                    </Box>
                    {isExpanded && dose && <DoseDetails dose={dose} />}
                </Box>
            </>
        )
    );
}
